/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import InputMask from 'react-input-mask'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import classNames from 'classnames/bind'
import * as styles from './Input.scss'

const cx = classNames.bind(styles)

type State = 'active' | 'valid' | 'alert' | 'warning' | 'default'

interface IProps {
  name?: string,
  styleType?: string,
  mask?: string,
  type?: string,
  placeholder?: string,
  state?: State,
  value?: string,
  iconName?: string,
  meta?: any,
  id?: string,
  maxLength?: number,
  onChange?: (val: any) => any,
  onFocus?: (val: any) => any,
  onBlur?: (val: any) => any,
  size?: string,
  disabled?: boolean,
  autoFocus?: boolean,
}

interface IState {
  showPass: boolean,
  autoFilled: boolean,
}

class Input extends React.Component<IProps, IState> {
  private inputRef = null

  public readonly state = {
    showPass: false,
    autoFilled: false,
  }

  public componentDidMount () {
    if (this.props.autoFocus) {
      this.inputRef.focus()
    }
  }

  public componentDidUpdate (prevProps) {
    if (!prevProps.autoFocus && this.props.autoFocus) {
      this.inputRef.focus()
    }
    if (this.props.mask
      && (prevProps.value.length - this.props.value.length > 2
        || prevProps.value.length - this.props.value.length < -2)) {
      this.setState({
        autoFilled: true,
      })
    }
  }

  private togglePassword = (e) =>  {
    e.preventDefault()

    this.setState({
      showPass: !this.state.showPass,
    })
  }

  private handleType = (type) => {
    if (type === 'password') {
      return this.state.showPass ? 'text' : 'password'
    }
    if (type === 'cvv') {
      return 'password'
    }
    return type
  }

  public render () {
    const {
      state = 'default',
      iconName,
      styleType = 'default',
      size = 'medium',
      disabled,
      value,
      type,
      meta,
      mask: inputMask,
      ...restProps
    } = this.props
    const { showPass, autoFilled } = this.state

    const isPassword = type === 'password'

    return (
      <div className={cx(
        'root',
        styleType,
        state,
        size,
      )}>
        <InputMask
          {...restProps}
          type={this.handleType(type)}
          inputRef={r => this.inputRef = r}
          mask={(value && meta.touched) || !autoFilled ? inputMask : null}
          autoComplete={inputMask ? 'none' : 'on'}
          className={cx(
            'input',
            state,
            size,
            {
              disabled,
              withIcon: !!iconName,
            },
          )}
          value={value}
          disabled={disabled}
        />
        {isPassword && (
          <div className={cx(styles.passIcon, { visible: !!value })}>
            <ButtonWithIcon
              iconName={showPass ? 'eye' : 'eyeSlash'}
              styleType='noStyle'
              onClick={this.togglePassword}
              buttonType='button'
            />
          </div>
        )
        }
      </div>
    )
  }
}

export default Input
